module.exports = __webpack_public_path__ + "img/230.d2814834.jpg";